// extracted by mini-css-extract-plugin
export default {"submitBtn":"SubmitButton_submitBtn__4hS+d","disabled":"SubmitButton_disabled__2H9yI"};